<template>
  <div class="container">
    <div class="box-container">
      <div class="back-btn">
        <a href="javascript:history.back();">&laquo; Back To All Events</a>

        <div class="info-container" v-if="event">
          <div class="info-item">
            <b>Event:</b>
            {{event.name}}
          </div>

          <div class="info-item">
            <b>Start Date:</b>
            <span
              v-if="event.startDate"
            >{{event.startDate.toDate().getMonth()+1}}/{{event.startDate.toDate().getDate()}}/{{event.startDate.toDate().getFullYear()}}</span>
          </div>

          <div class="info-item">
            <b>End Date:</b>
            <span
              v-if="event.endDate"
            >{{event.endDate.toDate().getMonth()+1}}/{{event.endDate.toDate().getDate()}}/{{event.endDate.toDate().getFullYear()}}</span>
          </div>

          <div class="info-item">
            <b>Location:</b>
            {{event.address}}
          </div>
        </div>
      </div>

      <div class="switch-tab">
        <button>List</button>
      </div>

      <div class="informations">
        <table>
          <tr>
            <th></th>
            <th
              style="cursor: pointer"
              @click="order == 'asc' ? order = 'desc' : order = 'asc'"
            >Name {{order == 'asc' ? '&#9650;' : '&#9660;' }}</th>
            <th>
              <select v-model="gradYear" class="table-select">
                <option value>Grad Year</option>
                <option value="2020">2020</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
              </select>
            </th>

            <th>
              <select v-model="position" class="table-select">
                <option value>Position</option>
                <option
                  v-for="(position, index) in positions"
                  :value="position.ref"
                  :key="index"
                >{{position.name}}</option>
              </select>
            </th>

            <th>High School</th>
            <th>Club</th>
            <th>
              <span>Interest</span>
            </th>
            <th>
              Commited
              <br />College
            </th>
          </tr>
          <template v-if="athletesAttending.length > 0">
            <tr
              v-for="(athlete, index) in athletesAttending"
              :key="index"
              :class="[{'commited' : athlete.interestedColleges.length > 0 && isInterested(index)}, {'premium' : athlete.receipt}]"
            >
              <td class="star-icon" :class="{'favourited' : athlete.favourited}">
                <img
                  src="../assets/icons/star.png"
                  @click="athlete.favourited ? removeFromFavorites(athlete.ref) : addToFavorites(athlete.ref)"
                />
              </td>
              <td>
                <a
                  @click="$router.push(`/athletes/${athlete.id}`)"
                >{{athlete.lastName}}, {{athlete.firstName}}</a>
              </td>
              <td class="gradYear">{{athlete.graduatingYear}}</td>
              <td class="position">{{athlete.positionObject ? athlete.positionObject.name : ''}}</td>
              <td>
                <a
                  v-if="athlete.highSchoolObject"
                  @click="$router.push(`/highSchools/${athlete.highSchoolObject.id}`)"
                >{{athlete.highSchoolObject.name}}</a>
              </td>
              <td>
                <a
                  v-if="athlete.clubObject"
                  @click="$router.push(`/clubs/${athlete.clubObject.id}`)"
                >{{athlete.clubObject.name}}</a>
              </td>
              <td v-if="athlete.interestedColleges">{{athlete.interested ? 'Yes' : 'No'}}</td>
              <td>
                <a v-if="athlete.committedCollegeObject">{{athlete.committedCollegeObject.name}}</a>
              </td>
            </tr>
          </template>
        </table>
        <h2 v-if="athletesAttending.length <= 0 && executed">No athletes attending</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../db";
import firebase from "firebase/app";
export default {
  data() {
    return {
      event: null,
      tabOpen: "info",
      eventRef: null,
      athletesAttending: [],
      positions: [],
      order: "asc",
      searchInput: "",
      interested: "",
      baseQuery: null,
      currentQuery: null,
      executed: false,
      // positionWatch: null,
      // gradYearWatch: null
      position: "",
      gradYear: ""
    };
  },
  computed: {
    // gradYear: {
    //   get() {
    //     return this.$store.state.gradYear;
    //   },
    //   set(value) {
    //     this.$store.commit("setGradYear", value);
    //   }
    // },
    // position: {
    //   get() {
    //     return this.$store.state.position;
    //   },
    //   set(value) {
    //     this.$store.commit("setPosition", value);
    //   }
    // }
  },
  created() {
    // this.positionWatch = this.$store.watch(
    //   state => state.position,
    //   () => {
    //     this.executeQuery();
    //   }
    // );

    // this.gradYearWatch = this.$store.watch(
    //   state => state.gradYear,
    //   () => {
    //     this.executeQuery();
    //   }
    // );

    db.collection("events")
      .doc(this.$route.params.id)
      .get()
      .then(event => {
        this.eventRef = event.ref;

        this.baseQuery = db
          .collection("athletes")
          .where("attendingEvents", "array-contains", this.eventRef);

        this.executeQuery();

        db.collection("positions")
          .get()
          .then(snap => {
            this.positions = snap.docs.map(position => {
              return {
                name: position.data().name,
                ref: position.ref
              };
            });
          });

        this.event = event.data();
      });
  },
  methods: {
    isInterested(index) {
      return this.athletesAttending[index].interestedColleges.find(
        ref => ref.id == this.$store.state.coach.college.id
      );
    },
    queryBuilder() {
      this.currentQuery = this.baseQuery.orderBy("searchName", this.order);

      if (this.gradYear !== "" && this.gradYear !== null) {
        this.currentQuery = this.currentQuery.where(
          "graduatingYear",
          "==",
          parseInt(this.gradYear, 10)
        );
      }

      if (this.position !== "" && this.position !== null) {
        this.currentQuery = this.currentQuery.where(
          "position",
          "==",
          this.position
        );
      }
    },
    executeQuery() {
      this.queryBuilder();
      this.executed = false;

      this.currentQuery.get().then(snap => {
        this.executed = true;
        this.athletesAttending = snap.docs
          .filter(athlete => athlete.data().graduatingYear > 2019)
          .map(doc => {
            let interested = false;
            let favourited = false;

            if (doc.data().interestedColleges) {
              if (
                doc
                  .data()
                  .interestedColleges.map(college => college.id)
                  .includes(this.$store.state.coach.college.id)
              ) {
                interested = true;
              }
            }

            if (
              this.$store.state.coach.favoritedUsers &&
              this.$store.state.coach.favoritedUsers.find(
                athlete => athlete.path == doc.ref.path
              )
            ) {
              favourited = true;
            }

            return {
              ref: doc.ref,
              ...doc.data(),
              id: doc.id,
              interested,
              favourited
            };
          });
      });
    },
    addToFavorites(athleteRef) {
      db.collection("coaches")
        .doc(this.$store.state.coach.id)
        .update({
          favoritedUsers: firebase.firestore.FieldValue.arrayUnion(athleteRef)
        })
        .then(res => {
          this.$store
            .dispatch("getCoachDoc", this.$store.state.coach.id)
            .then(() => {
              let updatedAthletes = this.athletesAttending.map(athlete => {
                let favourited = false;
                if (
                  this.$store.state.coach.favoritedUsers &&
                  this.$store.state.coach.favoritedUsers.find(
                    favAthlete => favAthlete.path == athlete.ref.path
                  )
                ) {
                  favourited = true;
                }
                return { ...athlete, favourited };
              });
              this.$set(this, "athletesAttending", updatedAthletes);
            });
        });
    },
    removeFromFavorites(athleteRef) {
      db.collection("coaches")
        .doc(this.$store.state.coach.id)
        .update({
          favoritedUsers: firebase.firestore.FieldValue.arrayRemove(athleteRef)
        })
        .then(() => {
          this.$store
            .dispatch("getCoachDoc", this.$store.state.coach.id)
            .then(() => {
              let updatedAthletes = this.athletesAttending.map(athlete => {
                let favourited = false;
                if (
                  this.$store.state.coach.favoritedUsers &&
                  this.$store.state.coach.favoritedUsers.find(
                    favAthlete => favAthlete.path == athlete.ref.path
                  )
                ) {
                  favourited = true;
                }
                return { ...athlete, favourited };
              });
              this.$set(this, "athletesAttending", updatedAthletes);
            });
        });
    }
  },
  watch: {
    order() {
      this.executeQuery();
    },
    gradYear() {
      this.executeQuery();
    },
    position() {
      this.executeQuery();
    }
  },
  destroyed() {
    // this.positionWatch();
    // this.gradYearWatch();
  }
};
</script>

<style lang="scss" scoped>
.informations {
  display: flex;
  flex-direction: column;

  h1 {
    text-align: center;
    width: 100%;
    margin-top: 50px;
  }

  h2 {
    align-self: center;
    margin-top: 50px;
  }
}

.info {
  width: 50%;
  border-right: 1px solid #707070;
  border-left: 1px solid #707070;
}

.list {
  padding: 20px;
}

.list ul li a {
  color: #1a348d;
}

img.photo-user {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  display: block;
  padding: 20px;
  margin: 0 auto;
}

table {
  border-top: 1px solid #707070;
}

table tr th:nth-child(2),
table tr td:nth-child(2) {
  border-right: none;
}

table tr th:first-child,
table tr td:first-child {
  border-right: 1px solid #707070;
}

table tr td:first-child {
  text-align: right;
}
</style>